// extracted by mini-css-extract-plugin
export default {"backdrop":"FullScreenImage_backdrop__sBGLb","modal":"FullScreenImage_modal__28Sey","fullImage":"FullScreenImage_fullImage__cDuH1"};